<div class="confirm-overlay" *ngIf="confirmService.confirmation$ | async as notification">
  <div @confirm class="confirm info">
    <div class="center">{{ messageText(notification) | translate }}</div>
    <div class="buttons">
      <button (click)="cancel()">{{ rejectText(notification) | translate }}</button>
      <button (click)="approve()">{{ confirmText(notification) | translate }}</button>
    </div>
  </div>
</div>
